import { unstable_createMuiStrictModeTheme } from '@material-ui/core/styles';

const Theme = unstable_createMuiStrictModeTheme({
    palette: {
        primary: {
            main: "#2892fe"
        },
        text: {
            primary: "#455A64"
        }
    },
    custom: {
        colors: {
            baseBgColor: "#EFF1F9",
            fontDark: "#212121",
            fontDefault: "#455A64",
            fontLight: "#607D8B",
            fontLighter: "#90A4AE",
            fontLightest: "#CFD8DC",
            border: "rgba(0, 0, 0, 0.24)",
            borderLight: "rgba(0, 0, 0, 0.12)",
        }
    },
    typography: {
        button: {
          textTransform: 'none'
        }
    }
});

export default Theme;